/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Fork_HintInputs */

const cs_templates_empty_cta_fork_hint = /** @type {(inputs: Templates_Empty_Cta_Fork_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebo zkopírujte systémovou šablonu z filtru Vše.`)
};

const en_templates_empty_cta_fork_hint = /** @type {(inputs: Templates_Empty_Cta_Fork_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or fork a system template from the All filter.`)
};

/**
* | output |
* | --- |
* | "Or fork a system template from the All filter." |
*
* @param {Templates_Empty_Cta_Fork_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_fork_hint = /** @type {((inputs?: Templates_Empty_Cta_Fork_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Fork_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_fork_hint(inputs)
	return cs_templates_empty_cta_fork_hint(inputs)
});